import { createContext } from "react";
import { DEFAULT_VARIANT, DEFAULT_SIZE } from "./utils";
export const ButtonContext = createContext({
    size: DEFAULT_SIZE,
    variant: DEFAULT_VARIANT,
});
